import { Link, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import AdminRoute from "./components/AdminRoute";
import Shop from "./pages/Shop";
import Product from "./pages/Product";
import Feed from "./pages/Feed";
import Admin from "./pages/Admin";

function NotFound() {
  return (
    <div className="ap-notfound">
      <p className="ap-notfound__code">404</p>
      <p className="ap-muted">This page is not on the rack.</p>
      <Link to="/" className="ap-btn">
        Back to the stack
      </Link>
    </div>
  );
}

/**
 * Route table and chrome only. Data fetching, modals and socket wiring all live
 * inside the individual pages — App stays small on purpose.
 */
export default function App() {
  return (
    <div className="ap-shell">
      <Header />
      <main>
        <Routes>
          {/* The only public page. Everything else is operator-only, and the
              API enforces the same split. */}
          <Route path="/" element={<Shop />} />
          <Route path="/shop" element={<Shop />} />
          <Route
            path="/p/:productId"
            element={
              <AdminRoute>
                <Product />
              </AdminRoute>
            }
          />
          <Route
            path="/feed"
            element={
              <AdminRoute>
                <Feed />
              </AdminRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <Admin />
              </AdminRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
